import {
  IDiseasesTag,
  IDiseasesTagArgs,
  IDiseasesTagManagementState,
  IDiseasesTagPayload
} from '../@type';
import { GET_DISEASES_TAG_MANAGEMENT } from '../constants';
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'app/utils/constant';
import diseasesTagManagementServices from '../service';

export const getDiseasesTag = createAsyncThunk<
  IDiseasesTagPayload,
  IDiseasesTagArgs,
  ThunkAPIConfig
>(GET_DISEASES_TAG_MANAGEMENT, async (args, { dispatch, rejectWithValue }) => {
  try {
    const params = {
      ...args,
      page: args?.page || 1,
      limit: args?.limit || PAGE_SIZE
    };

    const { data } =
      await diseasesTagManagementServices.getDiseasesTagManagementList(
        params as any
      );
    const { result } = data.data;

    return {
      data: result
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDiseasesTagBuilder = (
  builder: ActionReducerMapBuilder<IDiseasesTagManagementState>
) => {
  const { pending, fulfilled, rejected } = getDiseasesTag;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data } = action.payload;
      draftState.loading = false;
      draftState.diseasesTagData = data;
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
